"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _reactRedux = require("react-redux");

var _actions = require("../../../redux/locations/actions");

var _selectors = require("../../../redux/locations/selectors");

var _selectors2 = require("../../../redux/attributes/selectors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SpecialtySelect = function SpecialtySelect(_ref) {
  var otherProps = _extends({}, _ref);

  var _useSearchSelector = (0, _selectors.useSearchSelector)(),
      filter = _useSearchSelector.filter,
      lastSearchId = _useSearchSelector.lastSearchId;

  var specialties = (0, _selectors2.useSpecialtiesSelector)();
  var dispatch = (0, _reactRedux.useDispatch)();
  var specialtyFilter = filter.specialty;
  return /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
    name: "specialty",
    style: {
      fontSize: "15px",
      fontFamily: "Lato",
      color: "#1c5c7f",
      lineHeight: "normal"
    },
    multiple: true,
    fullWidth: true,
    value: specialtyFilter.map(function (specialty) {
      return JSON.stringify(specialty);
    }),
    displayEmpty: true,
    renderValue: function renderValue(value) {
      var names = value.map(function (val) {
        return JSON.parse(val).label;
      }).join(", ");
      return value.length ? names : "Any specialty";
    },
    onChange: function onChange(event) {
      var values = event.target.value.map(function (value) {
        return JSON.parse(value);
      });
      console.log("specialyValues", values);
      dispatch((0, _actions.updateSpecialtyFilter)(values, lastSearchId)); // TODO: DammitJole
      // if (this.props.filter.specialty.length || (values && values.length)) {
      //     Tracker.trackEvent(CATEGORY, "specialty filter change", values.join(", "), "");
      // }
      //
      // api.trackSearchFilter(null, {
      //     ...this.props.filter,
      //     specialty: values,
      // }, this.state.specialties);
      //
      // this.props.updateFilter("specialty", values);
    }
  }, otherProps), _getSpecialtyOptions(specialties, specialtyFilter));
};

var _getSpecialtyOptions = function _getSpecialtyOptions(specialties, specialtyFilter) {
  if (specialties) {
    return specialties.map(function (specialty, index) {
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: "specialty-" + index,
        value: JSON.stringify({
          key: specialty.key,
          index: index,
          label: specialty.option.name
        })
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: !!specialtyFilter.find(function (specialtyFilter) {
          return specialtyFilter.key === specialty.key;
        }) ? "locator-form-filter-selected" : ""
      }, specialty.option.name));
    });
  }

  return null;
};

var _default = SpecialtySelect;
exports.default = _default;